// extracted by mini-css-extract-plugin
export default {"contextButton":"contex-button_contextButton__8bGAl","delete":"contex-button_delete__pBdWA"};